import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

//eslint-disable-next-line @typescript-eslint/naming-convention,prefer-arrow/prefer-arrow-functions
export default function HttpLoaderFactory(httpClient: HttpClient) {
  // Use absolute path for WebOS compatibility
  const baseHref = document.querySelector('base')?.href || '';
  return new TranslateHttpLoader(httpClient, `${baseHref}lang/`, '.json');
}
